import React, { useContext, useEffect } from 'react';

import DataContext from '../../context/dataContext';
import PortalContext from '../../context/dataContext';


import { ContainerBlock } from '../../styles';
import { ContainerPopupWrapper, AuthInformation } from './styled';

const NotificationInfo: React.FC = () => {

  const { errors, setErrors, successMsgs, setSuccessMsgs  } = useContext(DataContext);

  useEffect(() => {
    let time;
    const timer = () => {
      time = setInterval(() => {
        setSuccessMsgs(prev => prev.slice(0, -1));
        setErrors(prev => prev.slice(0, -1));
      }, 3000);
    };

    if (errors.length > 3) {
      setErrors(prev => prev.slice(0, -1));
    }
    if (successMsgs.length > 3) {
      setSuccessMsgs(prev => prev.slice(0, -1));

    }
    timer();

    return () => {
      clearInterval(time);
    };
  }, [errors, successMsgs]);

  return (
    <ContainerPopupWrapper>
      <ContainerBlock sm >
        {successMsgs.map((success, i) => (
          <AuthInformation className="-success" key={`${success}x{${i * 2}}`}>
            {success}
          </AuthInformation>
        ))}
        {errors.map((err, i) => (
          <AuthInformation className="-error" key={`${err}x{${i * 2}}`}>
            {err}
          </AuthInformation>
        ))}
      </ContainerBlock>
    </ContainerPopupWrapper>
  );
};

export default NotificationInfo;


